export default __webpack_public_path__ + "static/media/WeatherApp.b7c9383d.png";